import { useCallback, useState } from "react";
import { ResultData } from "../Result.modal";
import {
  LivenessErrorCode,
  LivenessResult,
  LIvenessStatus,
} from "../../../../../constants";
import { usePassportStore } from "../../../../../stores";

type Props = {
  resetState?: () => void;
  setShowResultModal?: (show: boolean) => void;
  onHandleResult: (result: ResultData) => void;
  onHandleCloseResult?: () => void;
  onHandleFinishResult?: () => void;
};

export const useOneKycResult = ({
  resetState,
  setShowResultModal,
  onHandleResult,
  onHandleCloseResult,
  onHandleFinishResult,
}: Props) => {
  const [loading, setLoading] = useState<boolean>(false);

  const store = usePassportStore();

  const handleResult = useCallback(
    async (data: any) => {
      resetState?.();
      setLoading(true);
      try {
        const { status: iabStatus, partner_session_id, error_code } =
          data || {};

        if (iabStatus === LIvenessStatus.Error) {
          onHandleResult({ status: iabStatus, errorCode: error_code });
          return;
        }

        const resultDetails = await store.verifyLiveness(partner_session_id);
        const { status, result, reason_code } = resultDetails || {};

        onHandleResult({
          status,
          result,
          errorCode: reason_code,
        });
      } catch (e) {
        onHandleResult({
          status: LIvenessStatus.Error,
          result: LivenessResult.Invalid,
          errorCode: LivenessErrorCode.GeneralError,
        });
      } finally {
        setLoading(false);
        setShowResultModal?.(true);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const handleCloseResult = () => {
    onHandleCloseResult?.();
    setShowResultModal?.(false);
  };

  const handleFinishResult = () => {
    onHandleFinishResult?.();
    setShowResultModal?.(false);
  };

  return {
    loading,
    handleResult,
    handleCloseResult,
    handleFinishResult,
  };
};
